import { push } from 'connected-react-router'
export const fetchPointsCashConfig = () => ({
  type: 'FETCH_POINTS_CASH_CONFIG',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/purchases/Pointcash/1`
    }
  }
})

export const fetchInstallments = data => ({
  type: 'FETCH_INSTALLMENTS',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'post',
      url: '/v1/purchases/CalculateInstallment',
      data
    }
  }
})

export const createPurchase = creditCardPayment => ({
  type: 'CREATE_PURCHASE',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'post',
      url: '/v1/purchases',
      data: {
        channelType: 'ONLINE',
        creditCardPayment
      }
    }
  }
})

export const authorizeWithToken = (
  OrderId,
  PaymentMoneyRequest,
  Token,
  TokenType,
  Resend
) => ({
  type: 'AUTHORIZE_TOKEN',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'post',
      url: '/v1/purchases/withToken',
      data: {
        OrderId: OrderId,
        PaymentMoneyRequest: PaymentMoneyRequest,
        Token: Token,
        TokenType: TokenType,
        Resend: Resend
      }
    }
  }
})

export const authorizeWithTokenResend = (
  OrderId,
  PaymentMoneyRequest,
  Token,
  TokenType,
  Resend
) => ({
  type: 'AUTHORIZE_RESEND',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'post',
      url: '/v1/purchases/generateToken',
      data: {
        OrderId: OrderId,
        PaymentMoneyRequest: PaymentMoneyRequest,
        Token: Token,
        TokenType: TokenType,
        Resend: Resend
      }
    }
  }
})

export const authorizeWithTokenLastTry = (
  OrderId,
  PaymentMoneyRequest,
  Token,
  TokenType,
  Resend
) => ({
  type: 'AUTHORIZE_TOKEN_LAST_TRY',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'post',
      url: '/v1/purchases/generateToken',
      data: {
        OrderId: OrderId,
        PaymentMoneyRequest: PaymentMoneyRequest,
        Token: Token,
        TokenType: TokenType,
        Resend: Resend
      }
    }
  }
})

export const redirectConfirmation = orderId => {
  return push(`/confirmation/${orderId}`)
}

export const success = () => ({
  type: 'SUCCESS'
})

export const fetchCashOnlyConfig = () => ({
  type: 'FETCH_CASH_ONLY_CONFIG',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/purchases/onlycash/1`
    }
  }
})

export default {
  fetchPointsCashConfig,
  fetchInstallments,
  createPurchase,
  redirectConfirmation,
  fetchCashOnlyConfig,
  authorizeWithToken,
  authorizeWithTokenResend,
  authorizeWithTokenLastTry
}



// WEBPACK FOOTER //
// ./src/features/Checkout/actions.js